import { delay } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { actions, api } from './';

export function* fetchUpsell(action) {
    yield call(delay, 650) // debounce here rather than within the Quote component

    const { params } = action.value

    try {
        const ratings = yield call(api.fetch, params)
        yield put(actions.fetchSuccess(ratings))
    } catch (e) {
        yield put(actions.fetchFailure(e))
    }
}

function* watchForFetchUpsell() {
    yield takeLatest(actions.FETCH_UPSELL, fetchUpsell)
}

export default function* root() {
    yield fork(watchForFetchUpsell)
}
